import React, { PureComponent } from 'react'
import { Observable } from 'rxjs'
import { RESPONSE_PENDING, RESPONSE_NOTFOUND } from '../constants/responses'
import { cache } from '../services/CMSService'

export default ({ request: fnFetchData }) => WrappedComponent => {
  if (!fnFetchData) throw new Error("[Prismic UniversalComponent] Missing parameter 'request' - must be an async call returning a Promise.")
  if (!WrappedComponent) throw new Error("[Prismic UniversalComponent] Missing parameter 'component' - must be a valid React Component")

  return class extends PureComponent {

    constructor (props) {
      super(props)
      if (!props.cmsCtx) throw new Error(`[Prismic - Component '${WrappedComponent.name}'] You must provide a props 'cmsCtx' which contains at least the object 'api' and the api endpoint.`)
      if (!props.cmsCtx.api) throw new Error(`[Prismic - Component '${WrappedComponent.name}'] You must provide a props 'cmsCtx' which contains at least the object 'api' and the api endpoint.`)
      if (!props.cmsCtx.endpoint) throw new Error(`[Prismic - Component '${WrappedComponent.name}'] You must provide a props 'cmsCtx' which contains at least the object 'api' and the api endpoint.`)
      this.state = { CMS_DATA: RESPONSE_PENDING }
    }

    componentDidMount () {
      cache({ request: fnFetchData, ctx: this.props.cmsCtx, props: this.props })
        .subscribe(CMS_DATA => {
          this.setState({ CMS_DATA })
        })
    }

    componentDidUpdate () {
      cache({ request: fnFetchData, ctx: this.props.cmsCtx, props: this.props })
        .subscribe(CMS_DATA => {
          this.setState({ CMS_DATA })
        })
    }

    render () {
      const newProps = { ...this.props, CMS_DATA: this.state.CMS_DATA }
      return <WrappedComponent {...newProps} />
    }
  }
}
